import { IMAGE_SRC, VideoSource } from "../common/constants";

export const scenesData: any = {
  sea: {
    thumbnail: IMAGE_SRC.seaThumb,
    status: {
      default: VideoSource.sea.seaDay,
      rainDay: VideoSource.sea.seaDayrain,
      night: VideoSource.sea.seaNight,
      rainNight: VideoSource.sea.seaNightrain,
    },
  },
  treeHouse: {
    thumbnail: IMAGE_SRC.treeHouse,
    status: {
      default: VideoSource.treeHouse.treeDay,
      rainDay: VideoSource.treeHouse.treeDayRain,
      night: VideoSource.treeHouse.treeNight,
      rainNight: VideoSource.treeHouse.treeNightRain,
    },
  },
  slowGarden: {
    thumbnail: IMAGE_SRC.slowdownThumb,
    status: {
      default: VideoSource.slowGarden.slowDay,
      night: VideoSource.slowGarden.slowNight,
    },
  },
  artRoom: {
    thumbnail: IMAGE_SRC.artroomThumb,
    status: {
      default: VideoSource.artRoom.artroomDay,
      rainDay: VideoSource.artRoom.artroomDayrain,
      night: VideoSource.artRoom.artroomNight,
      rainNight: VideoSource.artRoom.artroomNightRain,
    },
  },
  lakehouse: {
    thumbnail: IMAGE_SRC.lakehouseThumb,
    status: {
      default: VideoSource.lakeHouse.lakeHouseDay,
      rainDay: VideoSource.lakeHouse.lakeHouseDayrain,
      night: VideoSource.lakeHouse.lakeHouseNight,
      rainNight: VideoSource.lakeHouse.lakeHouseNightRain,
    },
  },

  chillvibes: {
    thumbnail: IMAGE_SRC.chillThumb,
    status: {
      default: VideoSource.chillvibes.chillDay,
      rainDay: VideoSource.chillvibes.chillDayRain,
      night: VideoSource.chillvibes.chillNight,
      rainNight: VideoSource.chillvibes.chillNightRain,
    },
  },

  fuji: {
    thumbnail: IMAGE_SRC.fujiThumb,
    status: {
      default: VideoSource.fuji.fujiDay,
      night: VideoSource.fuji.fujiNight,
    },
  },
  thewood: {
    thumbnail: IMAGE_SRC.thewoodThumb,
    status: {
      default: VideoSource.thewood.thewoodDay,
      rainDay: VideoSource.thewood.thewoodDayrain,
      night: VideoSource.thewood.thewoodNight,
      rainNight: VideoSource.thewood.thewoodNightRain,
    },
  },

  seoul: {
    thumbnail: IMAGE_SRC.seoulThumb,
    status: {
      default: VideoSource.seoul.seoulDay,
      rainDay: VideoSource.seoul.seoulDayRain,
      night: VideoSource.seoul.seoulNight,
      rainNight: VideoSource.seoul.seoulNightRain,
    },
  },
  greenHouse: {
    thumbnail: IMAGE_SRC.greenhouseThumb,
    status: {
      default: VideoSource.greenhouse.greenhouseDay,
      rainDay: VideoSource.greenhouse.greenhouseDay,
      night: VideoSource.greenhouse.greenhouseNight,
      rainNight: VideoSource.greenhouse.greenhouseNightRain,
    },
  },
  honolulu: {
    thumbnail: IMAGE_SRC.honoluluThumb,
    status: {
      default: VideoSource.honolulu.honoluluDay,
      rainDay: VideoSource.honolulu.honoluluRain,
      night: VideoSource.honolulu.honoluluNight,
      rainNight: VideoSource.honolulu.honoluluNightRain,
    },
  },

  van: {
    thumbnail: IMAGE_SRC.vanThumb,
    status: {
      default: VideoSource.van.vanDay,
      rainDay: VideoSource.van.vanDayRain,
      night: VideoSource.van.vanNight,
      rainNight: VideoSource.van.vanNightRain,
    },
  },
  summer: {
    thumbnail: IMAGE_SRC.summerThumb,
    status: {
      default: VideoSource.summer.summerDay,
      rainDay: VideoSource.summer.summerDayRain,
      night: VideoSource.summer.summerNight,
      rainNight: VideoSource.summer.summerNightRain,
    },
  },
  dreaming: {
    thumbnail: IMAGE_SRC.dreamingThumb,
    status: {
      default: VideoSource.dreaming.dreamingNight,
      night: VideoSource.dreaming.dreamingWatter,
    },
  },
  future: {
    thumbnail: IMAGE_SRC.futureThumb,
    status: {
      default: VideoSource.future.furure,
      night: VideoSource.future.futureGalaxy,
    },
  },
  cafe: {
    thumbnail: IMAGE_SRC.cafeThumb,
    status: {
      default: VideoSource.cafe.dayCafe,
      rainDay: VideoSource.cafe.dayCafeRain,
      night: VideoSource.cafe.nightCafe,
      rainNight: VideoSource.cafe.nightCafeRain,
    },
  },
};
export const setScenesData = [
  {
    id: "Sea",
    thumbnail: IMAGE_SRC.seaThumb,
    scenesType: scenesData.sea,
    primeum: false,
  },
  {
    id: "TreeHouse",
    thumbnail: IMAGE_SRC.treeHouse,
    scenesType: scenesData.treeHouse,
    primeum: false,
  },

  {
    id: "slow garden",
    thumbnail: IMAGE_SRC.slowdownThumb,
    scenesType: scenesData.slowGarden,
    primeum: true,
  },
  {
    id: "art room",
    thumbnail: IMAGE_SRC.artroomThumb,
    scenesType: scenesData.artRoom,
    primeum: false,
  },
  {
    id: "lake house",
    thumbnail: IMAGE_SRC.lakehouseThumb,
    scenesType: scenesData.lakehouse,
    primeum: false,
  },
  {
    id: "lofi vibes",
    thumbnail: IMAGE_SRC.chillThumb,
    scenesType: scenesData.chillvibes,
    primeum: false,
  },

  {
    id: "Fuji",
    thumbnail: IMAGE_SRC.fujiThumb,
    scenesType: scenesData.fuji,
    primeum: true,
  },
  {
    id: "The woods",
    thumbnail: IMAGE_SRC.thewoodThumb,
    scenesType: scenesData.thewood,
    primeum: false,
  },
  {
    id: "seoul",
    thumbnail: IMAGE_SRC.seoulThumb,
    scenesType: scenesData.seoul,
    primeum: false,
  },
  {
    id: "green house",
    thumbnail: IMAGE_SRC.greenhouseThumb,
    scenesType: scenesData.greenHouse,
    primeum: false,
  },
  {
    id: "honolulu",
    thumbnail: IMAGE_SRC.honoluluThumb,
    scenesType: scenesData.honolulu,
    primeum: false,
  },
  {
    id: "van",
    thumbnail: IMAGE_SRC.vanThumb,
    scenesType: scenesData.van,
    primeum: false,
  },
  {
    id: "summer",
    thumbnail: IMAGE_SRC.summerThumb,
    scenesType: scenesData.summer,
    primeum: false,
  },
  {
    id: "dreaming",
    thumbnail: IMAGE_SRC.dreamingThumb,
    scenesType: scenesData.dreaming,
    primeum: true,
  },
  {
    id: "future",
    thumbnail: IMAGE_SRC.futureThumb,
    scenesType: scenesData.future,
    primeum: true,
  },
  {
    id: "cafe",
    thumbnail: IMAGE_SRC.cafeThumb,
    scenesType: scenesData.cafe,
    primeum: false,
  },
];
